import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import { hasRole } from '../../../utils/userRoles';
import MultiSelect from '../../formElements/MultiSelect';
import Switch from '../../formElements/Switch';
import AccordionHeader from '../../ui/accordion/AccordionHeader';
import AccordionIcon from '../../ui/accordion/AccordionIcon';

import AutomaticAppointment from './AutomaticAppointment';

import app from '../../../app.module.css';
import form from '../../../commonStyles/formStyles.module.css';
import local from './appointmentsAdmin.module.css';

const AutomaticAppointmentConfiguration = ({
    contractAppointmentTypes,
    preSelectedAutomaticAppointmentTypeIds,
    preSelectedAutomaticAppointmentTypes,
    automaticAppointments,
    onAutomaticAppointmentTypeChange,
    onUpdateAutomaticAppointment,
    acceptedRoles,
    errors,
    clearError,
    keys
}) => {
    // LOCAL STATE
    const [expanded, setExpanded] = useState('');

    // STORE STATE
    const roles = useSelector((state) => state.entities.userService.loggedInUser.roles);

    // FNs
    const onAccordionChange = (panel) => setExpanded(expanded === panel ? '' : panel);

    // RENDER
    return (
        <div className={local.appointmentsSection}>
            <h2 className={app.sectionHeading}>Automatic Appointment Configuration</h2>
            <div className={form.formSection}>
                <div className={form.formColumn}>
                    <MultiSelect
                        id="automaticAppointmentTypes"
                        key={keys.automaticAppointmentTypes}
                        disabled={!hasRole(acceptedRoles, roles)}
                        label={'Appointment Types'}
                        placeholder="Select appointment types..."
                        menuItems={contractAppointmentTypes || []}
                        preSelectedIds={preSelectedAutomaticAppointmentTypeIds}
                        preSelects={preSelectedAutomaticAppointmentTypes}
                        nonEditableIds={preSelectedAutomaticAppointmentTypeIds}
                        selectAllDisabled={true}
                        error={errors.automaticAppointmentTypes}
                        onChange={(chosenIds) => onAutomaticAppointmentTypeChange(chosenIds)}
                    />
                </div>
            </div>
            <div className={local.automaticAppointments}>
                {automaticAppointments.map((el) => (
                    <div key={el.id}>
                        <Accordion
                            data-testid={`automatic_appointment_accordion_${el.id}`}
                            expanded={expanded === el.id}
                            onChange={() => onAccordionChange(el.id)}
                            slotProps={{ transition: { mountOnEnter: true } }}
                            className={app.accordionDivider}>
                            <AccordionSummary
                                expandIcon={<AccordionIcon />}
                                aria-controls={`panel1a-content`}
                                id={`panel1a-header`}>
                                <AccordionHeader isValid={!errors[`accordion-${el.id}`]?.error}>
                                    {el.appointmentType}
                                </AccordionHeader>
                                <Switch
                                    id={`isAccordionActive-${el.id}`}
                                    checked={el.active}
                                    disabled={true}
                                    inline={true}
                                    onOff={true}
                                />
                            </AccordionSummary>
                            <AccordionDetails>
                                {expanded === el.id && (
                                    <AutomaticAppointment
                                        acceptedRoles={acceptedRoles}
                                        roles={roles}
                                        appointment={el}
                                        contractAppointmentTypes={contractAppointmentTypes}
                                        onUpdateAutomaticAppointment={onUpdateAutomaticAppointment}
                                        errors={errors}
                                        clearError={clearError}
                                        onClose={onAccordionChange}
                                    />
                                )}
                            </AccordionDetails>
                        </Accordion>
                    </div>
                ))}
            </div>
        </div>
    );
};

AutomaticAppointmentConfiguration.propTypes = {
    contractAppointmentTypes: PropTypes.arrayOf(PropTypes.object),
    preSelectedAutomaticAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string),
    preSelectedAutomaticAppointmentTypes: PropTypes.arrayOf(PropTypes.object),
    automaticAppointments: PropTypes.arrayOf(PropTypes.object),
    acceptedRoles: PropTypes.arrayOf(PropTypes.string),
    errors: PropTypes.object,
    clearError: PropTypes.func,
    keys: PropTypes.object,
    onAutomaticAppointmentTypeChange: PropTypes.func,
    onUpdateAutomaticAppointment: PropTypes.func
};

export default AutomaticAppointmentConfiguration;
